import { Controller } from "@hotwired/stimulus"

function findInShadowRootsById(root: ParentNode, id: string): HTMLElement | null {
  const docLike = root as Document | DocumentFragment
  if (typeof docLike.getElementById === "function") {
    const direct = docLike.getElementById(id)
    if (direct) return direct as HTMLElement
  }

  const walker = document.createTreeWalker(root as Node, NodeFilter.SHOW_ELEMENT)
  let node = walker.currentNode as HTMLElement | null

  while (node) {
    const anyNode = node as any
    if (anyNode.shadowRoot) {
      const found = findInShadowRootsById(anyNode.shadowRoot, id)
      if (found) return found
    }
    node = walker.nextNode() as HTMLElement | null
  }

  return null
}

export default class extends Controller<HTMLInputElement> {
  toggle() {
    const checked = this.element.checked
    const defaultImageEl = findInShadowRootsById(document, "front-cover-image")
    const whiteEl = findInShadowRootsById(document, "front-cover-white")
    const uploadedImageEl = findInShadowRootsById(
      document,
      "front-cover-uploaded-image",
    ) as HTMLImageElement | null

    const hasUploadedImage = uploadedImageEl && uploadedImageEl.dataset.hasUploadedImage === "true"

    if (defaultImageEl) {
      defaultImageEl.style.display = checked ? "none" : "block"
    }

    if (whiteEl) {
      whiteEl.style.display = checked && !hasUploadedImage ? "flex" : "none"
      if (whiteEl && checked && !hasUploadedImage) {
        whiteEl.style.alignItems = "center"
        whiteEl.style.justifyContent = "center"
      }
    }

    if (uploadedImageEl) {
      uploadedImageEl.style.display = checked && hasUploadedImage ? "block" : "none"
    }
  }
}
